<template>
  <div class="repayment-container">
    <!-- 悬浮头部 -->
    <div class="sticky-header">
      <header class="header">
        <p class="header-title">My Loan</p>
        <button
          class="header-button"
          @click="goRolloverPae()"
          v-if="repayment.dueDate != null && repayment.remainAmount != null"
        >
          Extension Payment
        </button>
      </header>

      <!-- 悬浮状态卡片 -->
      <div
        class="card status-card"
        style="margin-top: 10px"
        v-if="repayment.dueDate != null"
      >
        <div
          class="status-indicator"
          :class="repayment.remainingDays > 0 ? 'on-time' : 'overdue'"
        >
          <span class="days-count">{{
            Math.abs(repayment.remainingDays)
          }}</span>
          <span class="days-label">{{
            repayment.remainingDays > 0 ? "Remaining days" : "Days overdue"
          }}</span>
        </div>

        <div class="status-details">
          <div class="detail-item">
            <span class="detail-value"
              >${{ formatAmount(repayment.remainAmount, 0, ".", ".") }}</span
            >
            <span class="detail-label">Amount to pay</span>
          </div>
          <div class="detail-item">
            <span class="detail-value">{{
              formatDate(repayment.dueDate)
            }}</span>
            <span class="detail-label">Due date</span>
          </div>
        </div>
      </div>

      <!-- Loan closed message -->
      <div
        class="card status-card"
        style="margin-top: 10px; text-align: center;"
        v-if="loanClosed"
      >
        <div class="loan-closed-message">
          <p style="font-size: 16px; font-weight: 600; margin-bottom: 8px;">
            Loan successfully closed
          </p>
          <p style="font-size: 14px;">
            You can apply for a higher amount next time.
          </p>
        </div>
      </div>
    </div>

    <main class="content">
      <!-- 贷款详情卡片 -->
      <div
        class="card info-card"
        v-if="!(repayment.dueDate == null && repayment.remainAmount == null)"
      >
        <div class="info-row">
          <span>Móvil</span>
          <span
            >***
            {{ repayment.phone.substr(5, repayment.phone.length - 1) }}</span
          >
        </div>

        <!-- 银行选择区域 -->
        <!-- <div class="bank-selection">
          <div class="selection-header">
            <h4>Select payment method</h4>
            <p class="selection-subtitle">contact customer service at: <a href="mailto:contact@loanfund.cc" >contact@loanfund.cc</a>.
            </p>
          </div>

          <div class="payment-category" v-for="(methods, category) in bankMethods" :key="category">
            <div class="category-header" @click="toggleCategory(category)">
              <span class="category-title">{{ category === "Métodos de pago" ? "Payment Methods" : category }}</span>
              <span class="toggle-icon">{{ expandedCategories[category] ? '−' : '+' }}</span>
            </div>

            <div v-show="expandedCategories[category]" class="methods-list">
              <div
                  v-for="method in methods"
                  :key="method.repayCode"
                  class="method-item"
                  :class="{ selected: method.selected }"
                  @click="selectMethod(method)"
              >
                <div class="radio-wrapper">
                  <div class="custom-radio" :class="{ checked: method.selected }"></div>
                </div>
                <div class="method-info">
                  <div class="method-name">{{ method.repayMethodName }}</div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="info-row">
          <span>Status</span>
          <span class="status-badge">Prepare to pay</span>
        </div>
        <!-- <div class="info-row">
          <span>Name</span>
          <span>{{ repayment.name }}</span>
        </div> -->

        <div class="info-row">
          <span>Account holder:</span>
          <span>{{ repayment.titular }}</span>
        </div>

        <!-- Pay now button moved to inside the info-card -->
        <div style="margin-top: 20px; text-align: center;">
          <button
            class="primary-btn"
            @click="copyCLABE"
            style="width: 100%; max-width: 300px;"
          >
            Pay now
          </button>
        </div>
      </div>

      <!-- 无到期日时的卡片 -->
      <div
        class="card advice-card"
        v-if="repayment.dueDate == null && repayment.remainAmount != null"
      >
        <p class="advice-text">
          Maintain and take care of your credit, it would avoid an extra charge
          for the delay. We suggest making the payment with the following
          accounts:
        </p>
        <div class="info-row">
          <span>Account holder:</span>
          <span>{{ repayment.titular }}</span>
        </div>
      </div>

      <!-- Safe Repayment Reminder -->
      <div
        class="card warning-card"
        v-if="!(repayment.dueDate == null && repayment.remainAmount == null)"
        style="margin-top: 20px; background-color: #fff9e6; border-left: 4px solid #ffc107;"
      >
        <div style="display: flex; align-items: flex-start;">
          <span style="font-size: 18px; color: #ffc107; margin-right: 10px;"
            >⚠️</span
          >
          <div>
            <p style="font-weight: 600; margin: 0 0 8px 0; color: #333;">
              Safe Repayment Reminder
            </p>
            <p style="margin: 0 0 5px 0; font-size: 14px; color: #333;">
              Always repay using the UPIID shown in this App.
            </p>
            <p style="margin: 0; font-size: 14px; color: #333;">
              Do NOT trust any UPIID shared in WhatsApp or personal messages.
            </p>
          </div>
        </div>
      </div>

      <!-- UTR Input Section -->
      <div
        class="card utr-card"
        v-if="!(repayment.dueDate == null && repayment.remainAmount == null)"
        style="margin-top: 20px;"
      >
        <div class="utr-input-container">
          <label class="utr-label">Enter UTR Number</label>
          <p>
            After completing payment, please enter your 12-digit UTR(UPI Ref.
            No.) below ↓
          </p>
          <br />
          <div class="input-wrapper">
            <input
              v-model="utr"
              class="utr-input"
              type="text"
              placeholder="Enter 12-digit UTR number"
              maxlength="12"
            />
            <button class="paste-btn" @click="pasteUTR">Paste</button>
          </div>
          <div class="error-message" v-if="utr && !isValidUTR()">
            Please enter a valid 12-digit UTR number
          </div>

          <!-- Success message - only shown after successful submission -->
          <div class="success-message" v-if="utrSubmitted && utrSuccessMessage">
            {{ utrSuccessMessage }}
          </div>

          <button
            class="submit-utr-btn"
            @click="submitUTR"
            :disabled="!isValidUTR()"
          >
            Submit UTR
          </button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import CallApp from "callapp-lib";

export default {
  name: "Repayment",
  data() {
    return {
      repayment: {},
      bankMethods: {},
      repaymentCode: null,
      key: "",
      clabe: null,
      instance: null,
      showBankSelection: false,
      expandedCategories: {},
      utr: "",
      utrSubmitted: false,
      utrSuccessMessage: "",
      loanClosed: false, // Initially false, will be set to true based on API response
    };
  },
  mounted() {
    document.title = "My Loan";
  },
  created() {
    this.getDetailInfo();
  },
  methods: {
    formatDate(dateStr) {
      return dateStr ? dateStr.substr(0, 10) : "";
    },

    penaltyWaiver() {
      if (this.repayment.penaltyUrl) {
        window.open(this.repayment.penaltyUrl, "_blank");
        let keyStr = this.getParamQueryString(window.location.href, "key");
        this.$Http.pointH5Report(
          {
            key: keyStr,
            eventName: "open_penalty_waiver",
          },
          true,
        );
      }
    },
    formatAmount(
      amount,
      decimals = 2,
      decimalSeparator = ".",
      thousandSeparator = ",",
    ) {
      amount = Number(amount);
      if (isNaN(amount)) {
        return "";
      }
      const factor = Math.pow(10, decimals);
      amount = Math.round(amount * factor) / factor;
      let amountStr = amount.toFixed(decimals);
      const [integerPart, decimalPart] = amountStr.split(".");
      const integerPartWithSeparator = integerPart.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        thousandSeparator,
      );
      return (
        integerPartWithSeparator +
        (decimalPart ? decimalSeparator + decimalPart : "")
      );
    },
    async getDetailInfo() {
      let keyStr = this.getParamQueryString(window.location.href, "key");
      let res = await this.$Http.getRepaymentInfo({ key: keyStr }, true);
      this.repayment = res;

      // Check if loan is closed based on API response
      if (res.dueDate == null && res.remainAmount == null) {
        this.loanClosed = true;
      }

      // this.repaymentCode = res.repaymentBankCode

      // 获取银行方法
      try {
        let bankRes = await this.$Http.repaymentMethod({ key: keyStr });
        // 转换数据结构
        this.bankMethods = {
          "Payment Methods": Object.keys(bankRes).map((key) => ({
            repayCode: key,
            repayMethodName: key,
            selected: bankRes[key],
          })),
        };
        Object.keys(bankRes).map((key) => {
          if (bankRes[key]) {
            this.repaymentCode = key;
          }
        });
        this.initExpandedState();
      } catch (error) {
        console.error("Error fetching bank methods:", error);
      }
    },
    getParamQueryString(url, name) {
      let subStr = name + "=";
      if (url.indexOf(subStr) !== -1) {
        let arr = url.split(subStr);
        let sub1 = arr[1];
        if (sub1.indexOf("&") !== -1) {
          let arr2 = sub1.split("&");
          return arr2[0];
        }
        return sub1;
      }
      return "";
    },
    goRolloverPae() {
      let keyStr = this.getParamQueryString(window.location.href, "key");
      this.$router.push({ path: "/rollover", query: { key: keyStr } });
    },
    async copyCLABE() {
      try {
        let keyStr = this.getParamQueryString(window.location.href, "key");
        let responseInfo = await this.$Http.repaymentUrl(
          {
            key: keyStr,
            repayCode: this.repaymentCode,
          },
          false,
        );
        if (responseInfo && responseInfo.length > 0) {
          window.open(responseInfo, "_blank");
        }
        await this.$Http.pointH5Report(
          {
            key: keyStr,
            eventName: "click_pay_button",
          },
          true,
        );
      } catch (error) {
        console.error("Error:", error);
      }
    },
    initExpandedState() {
      const categories = Object.keys(this.bankMethods);
      let selectedCategory = null;
      selectedCategory = categories[0];

      // 查找当前选中的银行所在的分类
      categories.forEach((category) => {
        const methods = this.bankMethods[category];
        const hasSelected = methods.some((method) => method.selected);
        if (hasSelected) {
          selectedCategory = category;
        }
      });

      // 初始化所有分类为收起状态
      categories.forEach((category) => {
        this.$set(this.expandedCategories, category, false);
      });

      // 展开选中银行所在的分类
      if (selectedCategory) {
        this.$set(this.expandedCategories, selectedCategory, true);
        this.lastExpandedCategory = selectedCategory;
      } else if (categories.length > 0) {
        // 如果没有选中的银行，展开第一个分类
        this.$set(this.expandedCategories, categories[0], true);
        this.lastExpandedCategory = categories[0];
      }
    },
    toggleCategory(category) {
      if (this.expandedCategories[category]) {
        this.$set(this.expandedCategories, category, false);
        this.lastExpandedCategory = null;
      } else {
        // 收起之前展开的分类
        if (this.lastExpandedCategory) {
          this.$set(this.expandedCategories, this.lastExpandedCategory, false);
        }
        // 展开新的分类
        this.$set(this.expandedCategories, category, true);
        this.lastExpandedCategory = category;
      }
    },
    selectMethod(method) {
      // 重置所有方法的选中状态
      Object.keys(this.bankMethods).forEach((category) => {
        this.bankMethods[category].forEach((m) => {
          this.$set(m, "selected", false);
        });
      });

      // 设置当前选中方法
      this.$set(method, "selected", true);

      // 更新还款信息
      this.repaymentCode = method.repayCode;
      // 如果 repayMethodName 包含 "-"，只取前面部分
      const bankName = method.repayMethodName.includes("-")
        ? method.repayMethodName.split("-")[0]
        : method.repayMethodName;
      this.repayment.repaymentBankName = bankName;
      this.showBankSelection = false;
    },
    // UTR Validation
    isValidUTR() {
      // Check if UTR is exactly 12 digits
      return /^\d{12}$/.test(this.utr);
    },
    // Paste UTR from clipboard
    async pasteUTR() {
      try {
        const text = await navigator.clipboard.readText();
        // Only paste if it's a 12-digit number
        if (/^\d{12}$/.test(text)) {
          this.utr = text;
        } else {
          // If not a valid UTR, paste anyway but show error
          this.utr = text;
        }
      } catch (err) {
        console.error("Failed to read clipboard contents: ", err);
      }
    },
    // Submit UTR
    async submitUTR() {
      if (!this.isValidUTR()) {
        return;
      }

      try {
        let keyStr = this.getParamQueryString(window.location.href, "key");
        let response = await this.$Http.submitUrl(
          {
            key: keyStr,
            utr: this.utr,
            isExtend: false, // Set to false as per requirements
          },
          true,
        ); // Using form data

        // Handle response as needed
        console.log("UTR submitted successfully", response);

        // Show toast message for success
        // Assuming there's a toast library available like Vant
        if (this.$toast) {
          this.$toast.success("Success");
        } else {
          // Fallback to alert if no toast library
          alert("Success");
        }

        // Check if the response indicates the loan is now closed
        // This would depend on what the API returns
        if (response && response.loanClosed) {
          this.loanClosed = true;
          // Show toast for loan closed
          if (this.$toast) {
            this.$toast.success(
              "Loan successfully closed. You can apply for a higher amount next time.",
            );
          }
        } else if (
          response &&
          response.dueDate == null &&
          response.remainAmount == null
        ) {
          // If the response contains loan data that indicates it's closed
          this.loanClosed = true;
          // Show toast for loan closed
          if (this.$toast) {
            this.$toast.success(
              "Loan successfully closed. You can apply for a higher amount next time.",
            );
          }
        }

        // Set success state and message
        this.utrSubmitted = true;
        // Use a generic success message or extract from response if available
        this.utrSuccessMessage =
          response.message || "UTR submitted successfully!";

        // You might want to clear the UTR input after successful submission
        // this.utr = '';

        // Handle any other post-submission logic here
      } catch (error) {
        console.error("Error submitting UTR:", error);
        // Handle error appropriately
        this.utrSubmitted = false;
        this.utrSuccessMessage = "";

        // Show error toast
        if (this.$toast) {
          this.$toast.fail("Failed to submit UTR");
        }
      }
    },
  },
};
</script>

<style scoped>
/* 基础样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
    "Helvetica Neue", sans-serif;
}

.repayment-container {
  min-height: 100vh;
  background-color: #f5f7fa;
  color: #333;
}

/* 悬浮头部区域 */
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #f5f7fa;
  padding-bottom: 0px;
}

/* 头部样式 */
.header {
  background: linear-gradient(90deg, #7bc4ff 0%, #54a5e8 100%);
  color: white;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  flex: 1;
  text-align: center;
}

.header-button {
  background: transparent;
  border: none;
  color: white;
  font-size: 14px;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.header-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* 卡片通用样式 */
.card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  max-width: 600px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin: 0 auto;
  flex-direction: column;
}

/* 状态卡片 */
.status-card {
  display: flex;
  align-items: center;
  padding: 16px;
  background: linear-gradient(90deg, #7bc4ff 0%, #54a5e8 100%);
  color: white;
  margin-top: 10px;
}

.status-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px;
}

.days-count {
  font-size: 25px;
  font-weight: 700;
  line-height: 1;
}

.days-label {
  font-size: 13px;
  margin-top: 2px;
}

.status-details {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.detail-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.detail-value {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 2px;
  margin-top: 10px;
}

.detail-label {
  font-size: 12px;
  opacity: 0.9;
}

/* 内容区域 */
.content {
  padding-bottom: 200px;
  max-width: 600px;
  margin: 0 auto;
}

/* 信息卡片 */
.info-card {
  padding: 10px;
  position: relative;
  margin: 10px auto 0;
}

.info-row {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.info-row:last-child {
  border-bottom: none;
}

.bank-info {
  display: flex;
  align-items: center;
}

.status-badge {
  background-color: #e8f0fe;
  color: #2c82c9;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

/* 银行选择区域 */
.bank-selection {
  margin-top: 0px;
  margin-bottom: 0px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

.selection-header {
  margin-bottom: 15px;
}

.selection-header h4 {
  font-size: 16px;
  color: #333;
  margin-bottom: 5px;
}

.selection-subtitle {
  font-size: 12px;
  color: #d93025;
  line-height: 1.4;
}

.payment-category {
  margin-bottom: 15px;
}

.category-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.category-header:hover {
  background: #e9ecef;
}

.category-title {
  font-weight: 600;
  color: #444;
  font-size: 14px;
}

.toggle-icon {
  font-weight: bold;
  font-size: 16px;
  color: #666;
}

.methods-list {
  margin-top: 8px;
  border: 1px solid #eee;
  border-radius: 6px;
  overflow: hidden;
}

.method-item {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  cursor: pointer;
  transition: all 0.2s;
  border-bottom: 1px solid #eee;
}

.method-item:last-child {
  border-bottom: none;
}

.method-item:hover {
  background-color: #f8f9fa;
}

.method-item.selected {
  background-color: #f0f8ff;
  border-left: 3px solid #54a5e8;
}

.radio-wrapper {
  margin-right: 12px;
}

.custom-radio {
  width: 18px;
  height: 18px;
  border: 2px solid #ddd;
  border-radius: 50%;
  position: relative;
  transition: all 0.2s;
}

.custom-radio.checked {
  border-color: #54a5e8;
  background: linear-gradient(90deg, #7bc4ff 0%, #54a5e8 100%);
}

.penalty-waiver {
  margin-top: 10px;
}

.custom-radio.checked::after {
  content: "";
  position: absolute;
  width: 8px;
  height: 8px;
  background: white;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.method-info {
  flex: 1;
}

.method-name {
  font-size: 14px;
  color: #333;
}

/* 建议卡片 */
.advice-card {
  padding: 16px;
  margin: 0 20px;
}

.advice-text {
  margin-bottom: 12px;
  line-height: 1.5;
  color: #5f6368;
}

/* Warning Card Styles */
.warning-card {
  padding: 16px;
  margin: 0 20px;
  border-radius: 8px;
}

.warning-card p {
  line-height: 1.4;
}

/* UTR Input Styles */
.utr-card {
  padding: 16px;
  margin: 0 20px 20px;
}

.utr-label {
  display: block;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
  color: #333;
}

.input-wrapper {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.utr-input {
  flex: 1;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 16px;
  outline: none;
}

.utr-input:focus {
  border-color: #54a5e8;
}

.paste-btn {
  background-color: #f1f3f4;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 0 15px;
  font-size: 14px;
  cursor: pointer;
}

.paste-btn:hover {
  background-color: #e8eaed;
}

.error-message {
  color: #000000;
  font-size: 14px;
  margin-bottom: 10px;
}

.success-message {
  color: #2c82c9;
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: 500;
}

.submit-utr-btn {
  width: 100%;
  background: linear-gradient(90deg, #7bc4ff 0%, #54a5e8 100%);
  color: white;
  border: none;
  border-radius: 24px;
  padding: 14px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s;
}

.submit-utr-btn:hover:not(:disabled) {
  opacity: 0.9;
}

.submit-utr-btn:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

/* 操作按钮 */
.action-buttons {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px 20px;
  background-color: white;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
  max-width: 600px;
  margin: 0 auto;
}

.primary-btn {
  flex: 1;
  background: linear-gradient(90deg, #7bc4ff 0%, #54a5e8 100%);
  color: white;
  border: none;
  border-radius: 24px;
  padding: 14px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s;
}

.primary-btn:hover {
  opacity: 0.9;
}

.secondary-btn {
  flex: 1;
  background-color: white;
  color: #2c82c9;
  border: 1px solid #54a5e8;
  border-radius: 24px;
  padding: 14px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.secondary-btn:hover {
  background-color: #f5f5f5;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .status-card {
    flex-direction: column;
    text-align: center;
  }

  .status-indicator {
    margin-bottom: 10px;
    padding: 0;
  }

  .status-details {
    width: 100%;
  }

  .action-buttons {
    flex-direction: row;
    gap: 12px;
  }

  .primary-btn,
  .secondary-btn {
    width: 100%;
  }

  .card {
    margin: 0 10px 10px;
  }

  .info-card,
  .advice-card {
    margin: 0 10px;
  }
}

/* 状态颜色 */
.on-time {
  color: #ffffff;
}

.overdue {
  color: #ffffff;
}
</style>
